import { RefetchOptions } from 'react-query';
import {
  AsyncComponentHookResult,
  AsyncComponentHookResultBase,
} from '../Types/ComponentHookResult';

export const combineQueryResults = <T>(
  queryResults: AsyncComponentHookResultBase<any>[],
): AsyncComponentHookResult<T> => {
  return {
    ...queryResults.reduce((acc, queryResult) => {
      return {
        ...acc,
        isLoading: acc.isLoading || queryResult.isLoading,
        isError: acc.isError || queryResult.isError,
        isIdle: acc.isIdle || queryResult.isIdle,
        isFetching: acc.isFetching || queryResult.isFetching,
        error: acc.error || queryResult.error,
        refetch: async (options?: RefetchOptions) =>
          Promise.all([acc.refetch(options), queryResult.refetch(options)]),
      };
    }),
  };
};
